export const ONBOARDING_LAST_STEP_KEY = 'onboarding_last_step';
export const ONBOARDING_SECTION_COMPLETED_KEY = 'onboarding_section_completed';

const RESUMABLE_STEPS = new Set([
  '/onboarding/topics', '/onboarding/books',
  '/onboarding/read', '/onboarding/novel-read',
  '/onboarding/phone', '/onboarding/otp-verification', '/onboarding/name',
]);

export const setOnboardingLastStep = (path: string) => {
  if (!RESUMABLE_STEPS.has(path)) return;
  try { localStorage.setItem(ONBOARDING_LAST_STEP_KEY, path); } catch { /* unavailable storage */ }
};

export const markOnboardingSectionCompleted = () => {
  try {
    localStorage.setItem(ONBOARDING_SECTION_COMPLETED_KEY, 'true');
    // Rewards are transient (their React location state is not persisted).
    // Phone is the next durable onboarding checkpoint after reading.
    localStorage.setItem(ONBOARDING_LAST_STEP_KEY, '/onboarding/phone');
  } catch { /* unavailable storage */ }
};

export const isOnboardingSectionCompleted = () => {
  try { return localStorage.getItem(ONBOARDING_SECTION_COMPLETED_KEY) === 'true'; } catch { return false; }
};

export const getOnboardingResumePath = () => {
  try {
    const saved = localStorage.getItem(ONBOARDING_LAST_STEP_KEY);
    if (saved === '/onboarding/discovery') return '/onboarding/name';
    if (saved && RESUMABLE_STEPS.has(saved)) return saved;
  } catch { /* fall back to first step */ }
  return '/onboarding/topics';
};

export const clearOnboardingProgress = () => {
  try {
    localStorage.removeItem(ONBOARDING_LAST_STEP_KEY);
    localStorage.removeItem(ONBOARDING_SECTION_COMPLETED_KEY);
    localStorage.removeItem('onboarding_book_id');
  } catch { /* unavailable storage */ }
};
